import { ModelMapper } from "@api/mappers/mappers.types";

import { translateWithoutContext } from "@redux/modules/value/translations/translations.helpers";

import { StoreDetailsApiModel } from "lib/@types/service/store/localized/storeDetails.api.model";

import { StoreDetailsModel } from "./@types/storeDetails.model";

export const StoreDetailsMapper: ModelMapper<
    StoreDetailsApiModel,
    StoreDetailsModel
> = model => {
    return {
        address: model.address,
        code: model.code,
        fullName: translateWithoutContext("general.shopName", model.shopName),
        latitude: model.latitude,
        longitude: model.longitude,
        activeStore: !!model.activeStore,
        storeName: model.shopName,
        productAvailability: model.productAvailability,
        weekDayOpenings: model.weekDayOpenings,
    };
};

export const StoresMapper: ModelMapper<
    Array<StoreDetailsApiModel>,
    Array<StoreDetailsModel>
> = model => {
    return model.map(StoreDetailsMapper);
};
